<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <div class="row">
      <div>
        <h5>{{ copy.examInstructions }}</h5>
        <ul>
          <li v-for="(item, index) in copy.instructions" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
    <div>
      <div class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
          <thead>
            <tr>
              <th colspan="7" class="main-title">{{ copy.examList }}</th>
            </tr>
          </thead>
            <tbody>
              <tr>
                <th>{{ copy.examName }}</th>
                <th>{{ copy.startTime }}</th>
                <th>{{ copy.endTime }}</th>
                <th>{{ copy.teacherName }}</th>
                <th>{{ copy.score }}</th>
                <th>{{ copy.note }}</th>
                <th>{{ copy.status }}</th>
              </tr>
              <tr v-for="(item, index) in roomList" :key="index">
                <td :data-th="copy.examName">
                  {{item.name}}
                </td>
                <td :data-th="copy.startTime">
                  {{item.begin_at}}
                </td>
                <td :data-th="copy.endTime">
                  {{item.end_at}}
                </td>
                <td :data-th="copy.teacherName">
                  {{item.creator.name}}
                </td>
                <td :data-th="copy.score">
                  {{item.score!==null ? item.score : copy.notAnswered}}
                </td>
                <td :data-th="copy.note">
                  <div class="ellipsis">
                    {{item.note!==null ? item.note : copy.none}}
                  </div>
                </td>
                <td :data-th="copy.status">
                  <div v-if="item.score === null  && now < item.end_at">
                    <button v-if="now>=item.begin_at" type="button" class="btn btn-success" @click="goExam(item)">{{ copy.startExam }}</button>
                    <button v-else type="button" class="btn btn-success" disabled >{{ copy.notOpen }}</button>
                  </div>
                  <button v-else type="button" class="btn btn-success" @click="goExamDetail(item)">{{ copy.viewDetails }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import moment from 'moment';
import 'vue2-datepicker/index.css';
import api from '../store/api';
import 'balloon-css';
import { mapState } from 'vuex'
export default {
  name: 'Exam-hall',
  data () {
    return {
      pageCount: 10,
      pageIndex: 1,
      roomList: [],
      oralList: [],
      infoActive: false
    }
  },
  components: {
    Pagination
    // DatePicker
  },
  computed: {
    ...mapState({ group_id: state => state.auth.groupId }),
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          examInstructions: '考場說明:',
          instructions: [
            '考場開放時間為進入考場時間，在開放時間內進入後均可完整作答試卷，直到交卷為止。',
            '進入考場後未完成的交卷不得離開，若因網路斷線可重新登入後續考試。',
            '作答方式為單據逐句錄音，請逐句點選做答，系統不會自動進入下一句。',
            '每個單元題組全部句子完成後才能點選計算成績送出。',
            '計算成績送出後不可更改。'
          ],
          examList: '考場列表',
          examName: '考場名稱',
          startTime: '開始時間',
          endTime: '結束時間',
          teacherName: '老師姓名',
          score: '成績',
          note: '備註',
          status: '狀態',
          notAnswered: '尚未作答',
          none: '無',
          startExam: '開始測驗',
          notOpen: '尚未開放',
          viewDetails: '查看詳細'
        },
        en: {
          examInstructions: 'Exam Instructions:',
          instructions: [
            'The exam open time is when you may enter the exam room. Once you enter during the open period, you may complete the paper until submission.',
            'After entering the exam room, you may not leave before submitting an unfinished paper. If the network disconnects, log in again to continue.',
            'Record each sentence one by one. Select each sentence to answer; the system will not move to the next sentence automatically.',
            'You can calculate and submit your score only after completing all sentences in a unit set.',
            'Scores cannot be changed after submission.'
          ],
          examList: 'Exam List',
          examName: 'Exam Name',
          startTime: 'Start Time',
          endTime: 'End Time',
          teacherName: 'Teacher Name',
          score: 'Score',
          note: 'Note',
          status: 'Status',
          notAnswered: 'Not Answered',
          none: 'None',
          startExam: 'Start Exam',
          notOpen: 'Not Open Yet',
          viewDetails: 'View Details'
        }
      }
      return copy[this.currentLocale] || copy.tw
    },
    now () {
      return moment().format("YYYY-MM-DD HH:mm");
    }
  },
  mounted () {
    this.getRoomList()
  },
  methods: {
    goPage (el) {
      this.currentPage = el
      this.getPersonalData()
      let isGroup = el==='All'? false: true
      this.getLeaderBoardList(isGroup)
    },
    async getRoomList () {
      const { data } = await api.get(`liveabc/rooms?group_id=${this.group_id}&page=${this.pageIndex}&pageSize=10`)
      this.roomList = data.data
      this.pageCount = data.pageCount
      this.pageIndex = data.pageIndex
    },
    async getOralList (roomId) {
      const { data } = await api.get(`liveabc/rooms/${roomId}/oral_contents`)
      this.oralList = data.data
    },
    goExam (el) {
      this.$router.push({ name: 'Oral-exam', params:{ examId: el.id, repeatable: el.is_repeatable ? 1 : 0 }})
    },
    goExamDetail (el) {
      this.$router.push({ name: 'Exam-detail', params:{ examId: el.id }})
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRoomList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
//@import "~balloon-css/src/balloon";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
  .ellipsis {
    max-width: 100px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .info {
    border-radius: 50px;
    background-color: #000;
    margin: auto 5px;
    width: 16px;
    height: 16px;
    color: #fff;
    font-size: .8rem;
  }
  .info-content {
    padding: 10px;
    right: 0px;
    top: 25px;
    position: absolute;
    width: 200px;
    height: 100px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 500;
  }
  .hide {
    display: none;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
